module.exports = {"id":"about-gnomad","title":"About SFARI","content":"<h1>About SFARI</h1>\n<p>Place holder text</p>\n"}